export {}

const setZIndex = (arr: HTMLElement[], i: number, zIndex: string) => {
  const item = arr[i]

  if (!item) return
  item.style.zIndex = zIndex
}

const handleMouseOver = (item: HTMLElement, i: number, arr: HTMLElement[]) => {
  if (i !== arr.length - 1) {
    item.style.zIndex = "3"
    setZIndex(arr, i - 1, "2")
    setZIndex(arr, i + 1, "2")
    setZIndex(arr, i - 2, "1")
    setZIndex(arr, i + 2, "1")
  }

  if (arr[arr.length - 1]) arr[arr.length - 1]?.classList.remove("--last-not-hovered")
}

const handleMouseOut = (item: HTMLElement, i: number, arr: HTMLElement[]) => {
  if (i !== arr.length - 1) {
    item.style.zIndex = ""
    setZIndex(arr, i - 1, "")
    setZIndex(arr, i + 1, "")
    setZIndex(arr, i - 2, "")
    setZIndex(arr, i + 2, "")
  }

  if (arr[arr.length - 1]) arr[arr.length - 1]?.classList.add("--last-not-hovered")
}

const colorItems: NodeListOf<HTMLElement> = document.querySelectorAll(".i-color__item")

colorItems.forEach((item, i, arr) => {
  item.addEventListener("mouseover", () => handleMouseOver(item, i, Array.from(arr)))
  item.addEventListener("mouseout", () => handleMouseOut(item, i, Array.from(arr)))

  if (arr.length > 0) {
    arr[arr.length - 1]?.classList.add("--last-not-hovered")
  }
})
